import { render, staticRenderFns } from "./Url.vue?vue&type=template&id=1f96cf62&scoped=true"
import script from "./Url.vue?vue&type=script&lang=js"
export * from "./Url.vue?vue&type=script&lang=js"
import style0 from "./Url.vue?vue&type=style&index=0&id=1f96cf62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f96cf62",
  null
  
)

export default component.exports